import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/my-account")({ beforeLoad: redirectTo("/dashboard") });
